module.exports = __webpack_public_path__ + "img/bg-magento-find-out@2x.3cb6eac8.webp";